/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as LettersRouteImport } from './routes/letters'
import { Route as MastersRouteImport } from './routes/masters'
import { Route as MembersRouteImport } from './routes/members'
import { Route as OrganizationsRouteImport } from './routes/organizations'
import { Route as ReportsRouteImport } from './routes/reports'
import { Route as ApplicationsIndexRouteImport } from './routes/applications/index'
import { Route as ApplicationsIdRouteImport } from './routes/applications/$id'
import { Route as ApplicationsNewRouteImport } from './routes/applications/new'
import { Route as LettersIndexRouteImport } from './routes/letters/index'
import { Route as LettersIdRouteImport } from './routes/letters/$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LettersRoute = LettersRouteImport.update({
  id: '/letters',
  path: '/letters',
  getParentRoute: () => rootRouteImport,
} as any)
const MastersRoute = MastersRouteImport.update({
  id: '/masters',
  path: '/masters',
  getParentRoute: () => rootRouteImport,
} as any)
const MembersRoute = MembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsRoute = OrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationsIndexRoute = ApplicationsIndexRouteImport.update({
  id: '/applications/',
  path: '/applications/',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationsIdRoute = ApplicationsIdRouteImport.update({
  id: '/applications/$id',
  path: '/applications/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ApplicationsNewRoute = ApplicationsNewRouteImport.update({
  id: '/applications/new',
  path: '/applications/new',
  getParentRoute: () => rootRouteImport,
} as any)
const LettersIndexRoute = LettersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LettersRoute,
} as any)
const LettersIdRoute = LettersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => LettersRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/letters': typeof LettersRouteWithChildren
  '/masters': typeof MastersRoute
  '/members': typeof MembersRoute
  '/organizations': typeof OrganizationsRoute
  '/reports': typeof ReportsRoute
  '/applications/$id': typeof ApplicationsIdRoute
  '/applications/new': typeof ApplicationsNewRoute
  '/letters/$id': typeof LettersIdRoute
  '/applications/': typeof ApplicationsIndexRoute
  '/letters/': typeof LettersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/masters': typeof MastersRoute
  '/members': typeof MembersRoute
  '/organizations': typeof OrganizationsRoute
  '/reports': typeof ReportsRoute
  '/applications/$id': typeof ApplicationsIdRoute
  '/applications/new': typeof ApplicationsNewRoute
  '/letters/$id': typeof LettersIdRoute
  '/applications': typeof ApplicationsIndexRoute
  '/letters': typeof LettersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/letters': typeof LettersRouteWithChildren
  '/masters': typeof MastersRoute
  '/members': typeof MembersRoute
  '/organizations': typeof OrganizationsRoute
  '/reports': typeof ReportsRoute
  '/applications/$id': typeof ApplicationsIdRoute
  '/applications/new': typeof ApplicationsNewRoute
  '/letters/$id': typeof LettersIdRoute
  '/applications/': typeof ApplicationsIndexRoute
  '/letters/': typeof LettersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/letters'
    | '/masters'
    | '/members'
    | '/organizations'
    | '/reports'
    | '/applications/$id'
    | '/applications/new'
    | '/letters/$id'
    | '/applications/'
    | '/letters/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/masters'
    | '/members'
    | '/organizations'
    | '/reports'
    | '/applications/$id'
    | '/applications/new'
    | '/letters/$id'
    | '/applications'
    | '/letters'
  id:
    | '__root__'
    | '/'
    | '/auth'
    | '/letters'
    | '/masters'
    | '/members'
    | '/organizations'
    | '/reports'
    | '/applications/$id'
    | '/applications/new'
    | '/letters/$id'
    | '/applications/'
    | '/letters/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRoute
  LettersRoute: typeof LettersRouteWithChildren
  MastersRoute: typeof MastersRoute
  MembersRoute: typeof MembersRoute
  OrganizationsRoute: typeof OrganizationsRoute
  ReportsRoute: typeof ReportsRoute
  ApplicationsIdRoute: typeof ApplicationsIdRoute
  ApplicationsNewRoute: typeof ApplicationsNewRoute
  ApplicationsIndexRoute: typeof ApplicationsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/letters': {
      id: '/letters'
      path: '/letters'
      fullPath: '/letters'
      preLoaderRoute: typeof LettersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/masters': {
      id: '/masters'
      path: '/masters'
      fullPath: '/masters'
      preLoaderRoute: typeof MastersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/members': {
      id: '/members'
      path: '/members'
      fullPath: '/members'
      preLoaderRoute: typeof MembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations': {
      id: '/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports': {
      id: '/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications/': {
      id: '/applications/'
      path: '/applications'
      fullPath: '/applications/'
      preLoaderRoute: typeof ApplicationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications/$id': {
      id: '/applications/$id'
      path: '/applications/$id'
      fullPath: '/applications/$id'
      preLoaderRoute: typeof ApplicationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/applications/new': {
      id: '/applications/new'
      path: '/applications/new'
      fullPath: '/applications/new'
      preLoaderRoute: typeof ApplicationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/letters/': {
      id: '/letters/'
      path: '/'
      fullPath: '/letters/'
      preLoaderRoute: typeof LettersIndexRouteImport
      parentRoute: typeof LettersRoute
    }
    '/letters/$id': {
      id: '/letters/$id'
      path: '/$id'
      fullPath: '/letters/$id'
      preLoaderRoute: typeof LettersIdRouteImport
      parentRoute: typeof LettersRoute
    }
  }
}

interface LettersRouteChildren {
  LettersIdRoute: typeof LettersIdRoute
  LettersIndexRoute: typeof LettersIndexRoute
}

const LettersRouteChildren: LettersRouteChildren = {
  LettersIdRoute: LettersIdRoute,
  LettersIndexRoute: LettersIndexRoute,
}

const LettersRouteWithChildren =
  LettersRoute._addFileChildren(LettersRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRoute,
  LettersRoute: LettersRouteWithChildren,
  MastersRoute: MastersRoute,
  MembersRoute: MembersRoute,
  OrganizationsRoute: OrganizationsRoute,
  ReportsRoute: ReportsRoute,
  ApplicationsIdRoute: ApplicationsIdRoute,
  ApplicationsNewRoute: ApplicationsNewRoute,
  ApplicationsIndexRoute: ApplicationsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
